import { render } from "./TeacherEquipment.vue?vue&type=template&id=bea43fde&scoped=true"
import script from "./TeacherEquipment.vue?vue&type=script&lang=js"
export * from "./TeacherEquipment.vue?vue&type=script&lang=js"

import "./TeacherEquipment.vue?vue&type=style&index=0&id=bea43fde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea43fde"]])

export default __exports__